import React, { forwardRef } from "react";
import useIsOpenReturn from "../../../core/hooks/useIsOpenReturn";
import dayjs from "../../../utils/dayjs";
import { PriceStatus } from "../Calendar/Calendar";
import DateButton from "../DateButton/DateButton";
import { usePriceCalendarContext } from "./PriceCalendarContext";
import * as styles from "./PriceDateButton.module.css";
import PriceTag from "./PriceTag/PriceTag";
const getPriceStatus = (price, isCheapestPrice) => {
  if (price === "") {
    return PriceStatus.NO_PRICE;
  }
  return isCheapestPrice ? PriceStatus.CHEAPEST : PriceStatus.NORMAL;
};
const PriceDateButton = ({ value, getAriaLabel, ...props }, forwardedRef) => {
  const isOpenReturn = useIsOpenReturn();
  const { getPriceData } = usePriceCalendarContext();
  const priceTag = getPriceData(value);
  const { priceString, isCheapest } = priceTag;
  const priceStatus = getPriceStatus(priceString, isCheapest);
  return /* @__PURE__ */ React.createElement(DateButton, {
    ...props,
    "aria-label": getAriaLabel == null ? void 0 : getAriaLabel(dayjs(value).local().format("dddd, MMMM D, YYYY"), priceStatus, priceString),
    value,
    ref: forwardedRef,
    className: styles.root
  }, /* @__PURE__ */ React.createElement("div", {
    className: styles.wrapper
  }, dayjs(value).local().format("D"), !isOpenReturn && /* @__PURE__ */ React.createElement(PriceTag, {
    ...priceTag
  })));
};
var PriceDateButton_default = forwardRef(PriceDateButton);
export {
  PriceDateButton_default as default
};
